var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterprises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.32,
    cy: 79.6399,
    r: 79.5837,
    fill: "#F7FBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8698 57.9023C102.125 59.1654 121.632 79.2981 121.632 103.861V120.978L115.508 106.721C108.264 92.2373 93.8935 82.9764 77.8698 82.1249V101.716L39.009 69.9496L77.8698 38.2988V57.9023Z",
    fill: "url(#paint0_linear_64_23)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_23",
    x1: 80.3204,
    y1: 38.2988,
    x2: 80.3204,
    y2: 120.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A12E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986BEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.6796,
    height: 82.6796,
    fill: "white",
    transform: "matrix(-1 0 0 1 121.66 38.2993)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprises);
export default __webpack_public_path__ + "static/media/enterprises.8b83788dd7abca71a7d3535f5b6e14ac.svg";
export { ForwardRef as ReactComponent };